module.exports = __webpack_public_path__ + "static/media/portal-exit.f111422a.svg";